import { render, staticRenderFns } from "./BackgroundText.vue?vue&type=template&id=b1e016c2&scoped=true&"
import script from "./BackgroundText.vue?vue&type=script&lang=ts&"
export * from "./BackgroundText.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundText.vue?vue&type=style&index=0&id=b1e016c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e016c2",
  null
  
)

export default component.exports